import styled from 'styled-components';
import { Card } from '@minerva-analytics/pantheon';
import { LIGHT_GRAY, GRAY, BLACK } from '../../theme';
import media from '../../oldpantheon/utils/media';
import Select from '../../oldpantheon/components/Select';
import PendingInput from '../../oldpantheon/components/PendingInput';

const SMALL_DESKTOP = `48rem`;

export const SignupFormContainer = styled(Card)`
  padding: 3rem 3rem 1rem 3rem;
  background-color: #ffffff;
  border: none;
  box-shadow: 2px 3px 7px rgba(0, 0, 0, .1);
  border-radius: 0.625rem;
  max-width: 71.25rem;
  width: 90%;
  position: relative;
  overflow: scroll;

  ${media.tablet`padding: 2rem 2rem .5rem 2rem`}
`;

export const EmailInput = styled(PendingInput)`
  background-color: ${LIGHT_GRAY};
  width: ${(props) => props.stacked ? `100%` : `50%`};
  margin-right: 1rem;
  color: ${BLACK};
  padding: 0 1rem;
  height: 3.125rem;
  border: 2px solid ${GRAY};
  border-radius: 1.5rem;
  border-color: ${(props) => !props.validationState && `red`};
  margin-bottom: .5rem;
  margin-top: .5rem;

  @media only screen and (max-width: ${SMALL_DESKTOP}) {
    width: 100%;
  }
`;

export const SignSelect = styled(Select)`
  background-color: ${LIGHT_GRAY};
  border: 2px solid ${GRAY};
  border-radius: 1.5rem;

  color: ${BLACK};
  font-size: 1rem;
  padding: 0 1rem;
  margin-bottom: .5rem;
  margin-top: .5rem;

  width: ${(props) => props.stacked ? `100%` : `calc(50% - 2rem)`};
  height:3.125rem;
  line-height:3.125rem;

    @media only screen and (max-width: ${SMALL_DESKTOP}) {
    width: 100%;
  }
`;

export const SignupHeader = styled.h2`
  text-align: center;
  font-size: 2em;
  margin-bottom: 0.5rem;

  ${media.extraSmall`font-size: 1.5rem;`}
`;

export const HelpBlock = styled.p`
  color: ${(props) => props.validationState ? `green` : `red`};
  margin: 0 0 1rem 0;
  text-align: center;
`;

export const LegalText = styled.p`
  margin-top: 1.25rem;
  text-align: center;
  color: ${BLACK};
  font-size: .75rem;

  Link {
    color: ${BLACK};
  }
`;

export const ModalLogo = styled.img`
  width: 12.5rem;
  margin: 0 auto 1.25rem auto;
  display: block;

  @media only screen and (max-width: 21.875rem) {
    display: none;
  }
`;

export const SignUpSubheader = styled.h3`
  font-weight: lighter;
  text-align: center;
  font-size: 1.25rem;
  margin: 0rem auto .5rem auto;
  color: ${BLACK};
  max-width: 23.4rem;

  ${media.extraSmall`font-size: 1rem;`}

`;

export const SignUpButtonWrapper = styled.div`
  margin: 0 auto;
  display: block;
`;


export const ReturnToSiteText = styled.div`
  color: ${BLACK};
  text-align: center;
  margin-top: 1.25rem;
`;

export const ReturnToSiteLink = styled.div`
  cursor: pointer;
  color: ${BLACK};
  text-decoration: underline;
  font-weight: bold;
`;

export const SubheaderEmphasis = styled.span`
  font-style: italic;
  font-weight: 700;
`;
